import { render, staticRenderFns } from "./BudgetConfigurationList.vue?vue&type=template&id=0236817a&scoped=true&"
import script from "./BudgetConfigurationList.vue?vue&type=script&lang=js&"
export * from "./BudgetConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236817a",
  null
  
)

export default component.exports